import { SidebarMenu, SidebarMenuItem } from '@/components/ui/sidebar'
import { PlusCircle } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { SidebarHeader } from '@/components/ui/sidebar'
import { useActiveOrgId } from '@/hooks/useActiveOrgId'
import { Link, useNavigate } from '@tanstack/react-router'
import { useTheme } from '@/components/theme-provider'
import { SwitchOrg } from './switch-org'

export const DashboardSidebarHeader = () => {
  const { orgId: activeOrgId } = useActiveOrgId()
  const navigate = useNavigate()
  const { theme } = useTheme()

  return (
    <SidebarHeader className="p-4 flex flex-col border-b border-border/50">
      <div className="flex items-center my-2">
        <img
          src={theme === 'dark' ? '/logo-wide-white.png' : '/logo-wide.png'}
          alt="Inference.ai"
          className="h-8 w-auto dark:py-1 dark:pl-2 mr-auto cursor-pointer transition-opacity hover:opacity-80"
          // on click navigate to home page
          onClick={() => {
            navigate({
              to: '/$orgId/dashboard',
              params: { orgId: activeOrgId?.toString() || '' },
            })
          }}
        />
      </div>

      <SidebarMenu className="mt-3">
        <SidebarMenuItem className="min-h-[72px]">
          <SwitchOrg />
        </SidebarMenuItem>
      </SidebarMenu>

      <Button
        asChild
        className="w-full mt-4 mb-1 h-10 shadow-sm gap-2 font-medium text-sm"
        size="default"
      >
        <Link
          to="/$orgId/dashboard/servers/new"
          params={{ orgId: activeOrgId?.toString() || '' }}
          className="flex items-center"
        >
          <PlusCircle className="w-4 h-4 mr-1.5" />
          Create New Server
        </Link>
      </Button>
    </SidebarHeader>
  )
}
